import moment from 'moment';
import Store from '../store/store';

export const encodeString = (str) => {
  return encodeURI(String(str));
};

export const getUniqueID = () => {
  return Date.now();
};

export const getPreSignedUrl = async function (key, fileName) {
  const url = `${process.env.VUE_APP_DATA_API}/signed-url/${encodeString(
    `${key}_${getUniqueID()}`
  )}.${fileName.split('.')[1]}`;

  const myHeaders = new Headers();
  myHeaders.append(
    'Authorization',
    'Bearer ' + Store.state.user.signInUserSession.accessToken.jwtToken
  );

  myHeaders.append('content-type', 'application/json');

  const preSignedPayload = {
    filePath: fileName,
    prefix: 'output',
  };

  try {
    const preSignedRes = await fetch(url, {
      headers: myHeaders,
      body: JSON.stringify(preSignedPayload),
      method: 'POST',
    });

    if (preSignedRes.status === 200) return await preSignedRes.json();
    throw new Error(preSignedRes);
  } catch (err) {
    throw new Error(err);
  }
};

export const uploadFile = async function (signedUrl, file) {
  const formData = new FormData();
  formData.append('Content-Type', signedUrl['signature']['Content-Type']);
  formData.append('Policy', signedUrl['signature']['Policy']);
  formData.append('X-Amz-Algorithm', signedUrl['signature']['X-Amz-Algorithm']);
  formData.append(
    'X-Amz-Credential',
    signedUrl['signature']['X-Amz-Credential']
  );
  formData.append('X-Amz-Date', signedUrl['signature']['X-Amz-Date']);
  formData.append('X-amz-signature', signedUrl['signature']['X-amz-signature']);
  formData.append('acl', signedUrl['signature']['acl']);
  formData.append('bucket', signedUrl['signature']['bucket']);
  formData.append('key', signedUrl['signature']['key']);
  formData.append(
    'success_action_status',
    signedUrl['signature']['success_action_status']
  );
  formData.append('file', file);

  return await fetch(`https:${signedUrl['postEndpoint']}`, {
    body: formData,
    method: 'POST',
  });
};

export const isObjectType = (element) => {
  return element && typeof element === 'object' && !Array.isArray(element);
};

export const timestampToCETConvertor = (timestamp, dateFormat = null) => {
  const date = moment.tz(timestamp, 'Europe/Berlin').lang('de');
  if (dateFormat) {
    return date.format(dateFormat);
  }
  return date.format().split('+')[0];
};

export const getCETTimeStampFromDate = (date) => {
  return moment.tz(date, 'Europe/Berlin').valueOf();
};

export const convertDateToCETDate = (date) => {
  return moment.tz(date, 'Europe/Berlin');
};

export const debouncer = (
  func,
  timeout = 1500,
  context,
  contextVariable = 'debounceTimer'
) => {
  if (context[contextVariable]) {
    clearTimeout(context[contextVariable]);
  }
  context[contextVariable] = setTimeout(() => {
    func.apply(this);
  }, timeout);
};

export const getFlowLastId = (context) => {
  if (context.lastID == null) {
    context.lastID = Math.round(Math.random() * 100000 + new Date().getTime());
    return context.lastID;
  } else {
    ++context.lastID;
    return context.lastID;
  }
};

export const getFlowTaskDataObject = ({
  itemLabel = '',
  fileKey = '',
} = {}) => {
  return {
    id: new Date().getTime(),
    name: 'Start',
    caption: 'Start',
    icon: 'fa fa-play',
    ui: 'Start',
    active: true,
    shape: {
      type: 'circle',
      x: 500,
      y: 300,
      width: 99,
      height: 99,
      selected: false,
    },
    props: {
      trigger: 'formTrigger',
      timeTrigger: { freq: 'H', date: '01.03.2020', time: '08:00' },
      formTrigger: {
        elements: [
          {
            label: itemLabel,
            name: itemLabel,
            type: 'model',
            value: '' + fileKey + '',
            options: [],
            attributes: { required: true },
          },
        ],
      },
      eventTrigger: null,
      emailTrigger: null,
    },
    input: [],
    output: [],
    previousTaskId: null,
  };
};

export const getWizardData = () => {
  const wizardStyles = `<style>
  .button-wrapper #prevbtn,.button-wrapper #nextbtn {
      cursor: pointer;
      color: rgba(255, 255, 255, 0.951);
      border: 3px solid rgba(0, 0, 0, 0.916);
      background-color: rgba(0, 0, 0, 0.916);
      border-radius: 0.375em;
      font-weight: 400;
      line-height: 23px;
      padding: 0.5rem 1.5rem;
      font-size: 0.9375rem;
      margin: 25px 0px 25px 0px;
      letter-spacing: 0.6px;
      margin-right: 20px;
      min-width: 105px;
      text-transform: capitalize;
  }
  
  .button-wrapper #prevbtn:not([disabled]):hover,
          .button-wrapper #nextbtn:not([disabled]):hover {
            color: #fff;
            border: 3px solid #353434;
            background-color: #353434;
          }

          .wizard-tab-container .wizard-title {
            color: #5f697a;
            text-transform: capitalize;
            font-weight: 500;
            border-left: 2px solid #5f697a;
            padding-left: 10px;
            display: flex;
            align-items: center;
            font-size: 22px;
            margin-bottom: 30px;
          }



@media(max-width: 767px){
  .wizard-tab-container input[type="text"] {width: 100%;}

  .button-wrapper #prevbtn, .button-wrapper #nextbtn,.button-wrapper #submit-btn {
      min-width: 74px;
      padding: 0.5rem 10px;
  }
  
  .button-wrapper {
      justify-content: center;
  }
}
  </style>`;

  const wizardScript = ` <script>
  const wizardTabs = document.getElementsByClassName("title");
  const codelosForm = document.getElementById("codelosForm");
  let hiddenInputElement;
  let wizardTabsObject = {};
  let currentStep = 0;

  function tabDisplayer(tabID) {
    const tabs = Object.keys(wizardTabsObject);
    tabs.map((el, index) => {
      let wizardtab = document.getElementById("wizardtab" + index);

      if (index === tabID) {
        wizardtab.style.display = "block";
      } else {
        wizardtab.style.display = "none";
      }
    });
  }

  function validator() {
    const tabs = Object.keys(wizardTabsObject);
    const elementsArray = wizardTabsObject[tabs[currentStep]];

    if (!elementsArray || !elementsArray.length) return true;

    let isValid = true;

    for (let index = 0; index < elementsArray.length; index++) {
      const element = elementsArray[index];
      if (!isValid) break;

      if (element.required && element.value.trim() === "") {
        isValid = false;
        document.getElementById("submit-btn").click();
      }
    }

    return isValid;
  }

  function onPrevButtonClick() {
    const tabs = Object.keys(wizardTabsObject);

    if (currentStep - 1 === 0) {
      const prevbtn = document.getElementById("prevbtn");
      prevbtn.style.opacity = "0.6";
      prevbtn.disabled = "true";
    } else {
      const nextbtn = document.getElementById("nextbtn");
      const submitbtn = document.getElementById("submit-btn");
      nextbtn.style.opacity = "1";
      nextbtn.disabled = "";
      submitbtn.style.display = "none";
    }

    currentStep = currentStep - 1;

    tabDisplayer(currentStep);
  }
  function onNextButtonClick() {
    if (validator()) {
      const tabs = Object.keys(wizardTabsObject);
      if (currentStep + 1 === tabs.length - 1) {
        const nextbtn = document.getElementById("nextbtn");
        const submitbtn = document.getElementById("submit-btn");
        nextbtn.style.opacity = "0.6";
        nextbtn.disabled = "true";
        submitbtn.style.display = "block";
      } else {
        const prevbtn = document.getElementById("prevbtn");
        prevbtn.style.opacity = "1";
        prevbtn.disabled = "";
      }

      currentStep = currentStep + 1;

      tabDisplayer(currentStep);
    }
  }

  function injectButtons() {
    const buttonArray = [
      {
        id: "prevbtn",
        click: onPrevButtonClick,
        text: "vorherige",
        type: "button",
      },
      {
        id: "nextbtn",
        click: onNextButtonClick,
        text: "nächste",
        type: "button",
      },
      { id: "submit-btn", text: "Starten", type: "submit" },
    ];

    const buttonWrapper = document.createElement("div");
    buttonWrapper.setAttribute("class", "button-wrapper");
    buttonWrapper.style.display = "flex";

    buttonArray.map((props) => {
      let button = document.createElement("button");
      button.innerHTML = props.text;
      button.setAttribute("id", props.id);
      button.setAttribute("type", props.type);
      if (props.click) {
        button.addEventListener("click", props.click);
      }
      if (props.id === "prevbtn") {
        button.style.opacity = "0.6";
        button.disabled = "true";
      }

      if (props.id === "submit-btn") {
        button.style.display = "none";
      }
      buttonWrapper.appendChild(button);
    });
    codelosForm.appendChild(buttonWrapper);
    codelosForm.appendChild(hiddenInputElement);
  }

  function injectHtml() {
    const tabsArr = Object.keys(wizardTabsObject);

    tabsArr.map((el, index) => {
      const tab = document.createElement("div");
      tab.setAttribute("id", "wizardtab" + index);
      tab.setAttribute("class", "wizard-tab-container");

      const titleDiv = document.createElement("div");
      titleDiv.setAttribute("class", "wizard-title");
      titleDiv.innerHTML = el;

      tab.appendChild(titleDiv);

      if (index > 0) {
        tab.style.display = "none";
      }
      wizardTabsObject[el].map((elements) => {
        tab.appendChild(elements);
      });
      codelosForm.appendChild(tab);
    });

    injectButtons();
  }

  function createTabs() {
    wizardTabsObject = {};
    for (let index = 0; index < wizardTabs.length; index++) {
      const headerElement = wizardTabs[index];
      let sibling = headerElement.nextElementSibling;
      let siblingElements = [];

      while (sibling !== null && sibling !== wizardTabs[index + 1]) {
        siblingElements.push(sibling);
        sibling = sibling.nextElementSibling;
      }

      let arrayElements;

      if (index === wizardTabs.length - 1) {
        arrayElements = siblingElements.filter(
          (el) => el.id !== "submit-btn"
        );
      } else {
        arrayElements = siblingElements;
      }

      wizardTabsObject[headerElement.innerHTML] = arrayElements;
    }

    setTimeout(() => {
      hiddenInputElement = document.getElementsByName("id")[0];
      codelosForm.innerHTML = "";
      injectHtml();
    }, 10);
  }

  createTabs();
</script>`;

  const wizardData = [
    { name: 'wizard styles', value: wizardStyles },
    { name: 'wizard script', value: wizardScript },
  ];

  const defaultHtmlObject = {
    name: 'html',
    label: 'HTML ',
    placeholder: 'HTML',
    type: 'html',
    value: '',
    layoutItem: true,
    isWizardTemplate: true,
  };

  const wizardHtmlArray = wizardData.map((el) => {
    const tempObj = { ...defaultHtmlObject };
    tempObj.value = el.value;
    tempObj.name = el.name;
    tempObj.label = el.name;
    return tempObj;
  });

  return wizardHtmlArray;
};

export const mergeArray = (Array1, Array2, commanID) => {
  const mergedMap = new Map();

  Array1.forEach((item) => {
    mergedMap.set(item[commanID], { ...item });
  });

  Array2.forEach((item) => {
    if (mergedMap.has(item[commanID])) {
      mergedMap.set(item[commanID], {
        ...mergedMap.get(item[commanID]),
        ...item,
      });
    } else {
      mergedMap.set(item[commanID], { ...item });
    }
  });

  return Array.from(mergedMap.values());
};
